import { render } from "./TableUsersAssisted.vue?vue&type=template&id=718855cc&scoped=true"
import script from "./TableUsersAssisted.vue?vue&type=script&lang=js"
export * from "./TableUsersAssisted.vue?vue&type=script&lang=js"

import "./TableUsersAssisted.vue?vue&type=style&index=0&id=718855cc&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718855cc"]])

export default __exports__